var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1608 6.31052C18.2601 6.2122 18.3786 6.1341 18.5093 6.08078C18.6401 6.02746 18.7804 6 18.9223 6C19.0641 6 19.2045 6.02746 19.3352 6.08078C19.466 6.1341 19.5845 6.2122 19.6837 6.31052C20.0997 6.71855 20.1055 7.37789 19.6983 7.79297L11.0975 17.6619C10.9998 17.766 10.8813 17.8496 10.7492 17.9077C10.6171 17.9658 10.4742 17.9972 10.3292 17.9998C10.1842 18.0025 10.0402 17.9764 9.9059 17.9231C9.77165 17.8699 9.64999 17.7906 9.54839 17.6901L4.3149 12.5425C4.11306 12.3427 4 12.074 4 11.7942C4 11.5144 4.11306 11.2457 4.3149 11.0459C4.41417 10.9476 4.53264 10.8695 4.66339 10.8162C4.79414 10.7629 4.93454 10.7354 5.07636 10.7354C5.21818 10.7354 5.35857 10.7629 5.48932 10.8162C5.62007 10.8695 5.73855 10.9476 5.83782 11.0459L10.2771 15.4128L18.1317 6.34158C18.1408 6.33067 18.1505 6.32029 18.1608 6.31052Z",
    fill: "#728095"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/_check.99894967267c120918ea096bee821096.svg";
export { ForwardRef as ReactComponent };